import { BaseService } from './baseService';

class SenderNamesService extends BaseService<
	SenderName,
	'senderNameID',
	'senderNames'
> {
	constructor() {
		super('senderNameID', 'senderName', 'senderNames');
	}
}

// This type of exporting is intended to make sure service acts as a singleton.
export default new SenderNamesService();
